import {
  EventIcon,
  PropertiesIcon,
  ReferenceIcon,
} from 'components/common/Icons/gradientIcons';
import { FilterCheckbox, FilterSelectsGroupSection } from 'components/core';
import { TFilterOptions } from 'utils/context/FilterContext/types';
import DK from 'utils/dictionaries/filter_dictionary';
import { TFilterConfig } from 'utils/types';

const eventOption = (options: string[]): TFilterOptions =>
  options.map((opt) => ({
    variant: 'DatePicker',
    option: [opt, [DK.WITHIN], []],
  }));

const OrderFilters = (): TFilterConfig => {
  const properties = {
    id: 'properties',
    groupName: '',
    items: [
      {
        title: DK.ORDER_PROPERTIES,
        text: DK.ORDER_PROPERTIES_SUBTITLE,
        Component: (
          <FilterSelectsGroupSection
            title={DK.ORDER_PROPERTIES}
            buttonText={DK.ADD_PROPERTY}
            placeholder={DK.SELECT_PROPERTY}
            icons={{
              default: PropertiesIcon,
              [DK.ORDER_REFERENCE_KEY]: ReferenceIcon,
            }}
            options={[
              {
                value: DK.ORDER_REFERENCE_KEY,
                startVariant: 'Autocomplete',
                config: [
                  {
                    variant: 'Autocomplete',
                    option: ['', [DK.EQUALS, DK.NOT_EQUALS, DK.CONTAINS], []],
                  },
                ],
              },
            ]}
          />
        ),
      },
    ],
  };

  const dates = {
    id: 'dates',
    groupName: '',
    items: [
      {
        title: DK.DATES,
        text: DK.DATES_SUBTITLE,
        Component: (
          <FilterSelectsGroupSection
            title={DK.DATES}
            buttonText={DK.ADD_DATE}
            placeholder={DK.SELECT_DATE}
            icons={{ default: EventIcon }}
            options={[
              {
                value: DK.SUPPLIER_READY_DATE,
                config: eventOption([DK.PLANNED_DATETIME]),
              },
              {
                value: DK.ORDER_DUE_DATE,
                config: eventOption([DK.PLANNED_DATETIME]),
              },
              {
                value: DK.ORDER_SUBMISSION_DATE,
                config: eventOption([DK.PLANNED_DATETIME]),
              },
            ]}
          />
        ),
      },
      {
        title: DK.ORDER_TYPE,
        text: DK.ORDER_TYPE_SUBTITLE,
        Component: (
          <FilterCheckbox
            id={DK.ORDER_TYPE}
            options={[
              DK.PURCHASE_ORDER,
              DK.SALES_ORDER,
              DK.ADVANCED_SHIPMENT_NOTICE,
              DK.WAREHOUSE_MOVEMENT_ORDER,
            ]}
          />
        ),
      },
      {
        title: DK.ORDER_STATUS,
        text: DK.ORDER_STATUS_SUBTITLE,
        Component: (
          <FilterCheckbox
            id={DK.ORDER_STATUS}
            options={[
              DK.SUBMITTED,
              DK.RECEIVED,
              DK.PROCESSING,
              DK.ACCEPTED,
              DK.FULFILLED,
              DK.REJECTED,
              DK.CANCELED,
            ]}
          />
        ),
      },
    ],
  };

  return [properties, dates].map((group) =>
    Object.assign({}, group, { items: group.items.filter(Boolean) }),
  );
};

export default OrderFilters;
